import React, { useEffect, useState, useMemo } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

// really unfortunate issue with mobile Chrome and Safari, although Safari is the worst offender
// they expand or collapse the address bar as you scroll, and instead of recalculating the viewport height
// they just say 100vh is the viewport assuming the address bar is hidden.  Since it starts expanded
// the page ends up rendering larger than the viewport.
// we will detect if we are on a touch screen and tablet size or smaller, and if so
// we will use the innerHeight of the window instead of 100vh.

const isTouchScreen =
  navigator.maxTouchPoints === undefined || navigator.maxTouchPoints > 0

const defaultViewportHeight = isTouchScreen ? window.innerHeight : null

export const useViewportHeight = () => {
  const [viewportHeight, setViewportHeight] = useState<number | null>(
    defaultViewportHeight,
  )

  // since at least Safari doesn't trigger a resize event on orientation change
  // we need to manually trigger that event if they change orientation
  const isLandscape = useMediaQuery('(orientation: landscape)')
  const isPortrait = useMediaQuery('(orientation: portrait)')

  const handleResize = () => {
    setViewportHeight(window.innerHeight)
  }

  // trigger this on page load as well as anytime the device orientation changes
  useEffect(() => {
    // ignore all of this if we aren't on a smaller touch screen
    if (!isTouchScreen) return () => {}

    // we shouldn't have to worry about debouncing this
    // since most touchscreens don't let you resize browsers
    window.addEventListener('resize', handleResize as any)

    // fire it immediately to size everything on load
    const event = document.createEvent('HTMLEvents')
    event.initEvent('resize', true, false)
    document.dispatchEvent(event)

    return () => {
      window.removeEventListener('resize', handleResize as any)
    }
  }, [isTouchScreen, isLandscape, isPortrait])

  return viewportHeight
}
